import { useCallback } from "react";
import db from "state/db";

const useInflightSession = (crewCode, crewName) => {
    const addOrder = useCallback(
        async (sessionId, items, paymentMethod, note = "") => {
            const clientId =
                typeof crypto !== "undefined" && crypto.randomUUID
                    ? `${crewCode}-${sessionId}-${Date.now()}-${crypto.randomUUID()}`
                    : `${crewCode}-${sessionId}-${Date.now()}-${Math.random().toString(36).slice(2)}`;

            const subtotal = items.reduce((s, i) => s + i.totalAmount, 0);
            const totalCommission = items.reduce((s, i) => s + i.commission, 0);

            const order = {
                clientId,
                sessionId: sessionId.toString(),
                crewCode,
                crewName,
                items,
                subtotal,
                totalAmount: subtotal,
                totalCommission,
                paymentMethod,
                note,
                deviceTimestamp: new Date().toISOString(),
                syncStatus: "pending",
            };

            await db.orders.put(order);
            return order;
        },
        [crewCode, crewName]
    );

    const cancelLocalOrder = useCallback(async (clientId) => {
        await db.orders.update(clientId, { syncStatus: "cancelled", cancelledAt: new Date().toISOString() });
    }, []);

    const getSessionOrders = useCallback(
        (sessionId) =>
            db.orders
                .where("sessionId")
                .equals(sessionId.toString())
                .filter((o) => o.syncStatus !== "cancelled")
                .toArray(),
        []
    );

    const getPendingCount = useCallback(
        () => db.orders.where("syncStatus").equals("pending").count(),
        []
    );

    return { addOrder, cancelLocalOrder, getSessionOrders, getPendingCount };
};

export default useInflightSession;
